import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VisionInnovationConstruction from "./sections/VisionInnovationConstruction";
import TechnologyPillars from "./sections/TechnologyPillars";
import AcademicPracticalFoundation from "./sections/AcademicPracticalFoundation";
import SolutionsAndTechnology from "./sections/SolutionsAndTechnology";
import WeeklyDeals from "./sections/WeeklyDeals";
import ProjectsGrid from "./sections/ProjectsGrid";
import AffiliatePartners from "./sections/AffiliatePartners";
import NewsCenter from "./sections/NewsCenter";
import StrategicPartners from "./sections/StrategicPartners";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VisionInnovationConstruction />
      <TechnologyPillars />
      <AcademicPracticalFoundation />
      <SolutionsAndTechnology />
      <WeeklyDeals />
      <ProjectsGrid />
      <AffiliatePartners />
      <NewsCenter />
      <StrategicPartners />
      <Footer />
    </div>;
}